export default __webpack_public_path__ + "static/media/logo.3d6918b3.svg";